import React from "react";
import { useState, useEffect} from "react";
import { fetchConToken } from "helpers/fetch";
import { 
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer
} from 'recharts';
import PropTypes from 'prop-types';
//import CustomizedAxisTick from './CustomizedAxisTick';
import moment from "moment";
import Swal from 'sweetalert2';

import "./customLineChart.css"


export default function CustomLineChartNPKSmall(props) {
  
  //console.log("Updating Component");
  //console.log(props);
  const { start, query, sensors } = props;

  //console.log(start);
  //console.log(measure);

  //let [dataLine, setDataLine] = useState([]);
  //let [dataY, setY] = useState([]);
  //let [index, setIndex] = useState();
  

  

  let [dataNPK, setDataNPK] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const resp = await fetchConToken( `data?start=`+start+`&query=`+query+ `&sensors=`+sensors )
        const body = await resp.json();
        

        //Validar que metricas existan para leer, sino poner NO DATA
        //
        //
        //console.log("dataNPK:" + (body.data[0].n) &&  body.data[0].n.toFixed(2));
        
        if( body.ok ) {
            if(mounted) {
              let modifiedDate = body.data.map((entry)=>{
                return {time: entry.time, timeFormated: ''+moment(entry.time).format('ha'),  n: (entry.n != null) ? +entry.n.toFixed(2) : null,  p: (entry.p != null) ? +entry.p.toFixed(2) : null ,  k: (entry.k != null) ? +entry.k.toFixed(2) : null }
              })
              //console.log(data);
              setDataNPK(modifiedDate);

              //console.log("modifiedDate:", modifiedDate);
            }
        }else{
          Swal.fire('Error colectando metricas. code: 0x051', "No está autorizado", 'error');
        }
      } catch (error) {
        console.log(error);
        Swal.fire('Error colectando metricas. code: 0x052', "No existen metricas", 'error');
      }
    }
    fetchData();
    return () => mounted = false;
  }, [sensors])
  
  


  return (
    
       <ResponsiveContainer   >
          
          <LineChart
            /* width={200}
            height={300} */
            data={dataNPK}
            margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0,
            }}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="timeFormated" interval="preserveEnd" minTickGap={40} />
            <YAxis type="number" domain={['auto', 'auto']}/>
            <Tooltip />
            {/* <Legend /> */}
            <Line strokeWidth={2} type="monotone" dataKey="n" stroke="#8884d8" activeDot={{ r: 4 }} dot={false}/>
            <Line strokeWidth={2} type="monotone" dataKey="p" stroke="#82ca9d" dot={false} />
            <Line strokeWidth={2} type="monotone" dataKey="k" stroke="#85cafd" dot={false} /> 
          </LineChart>
        </ResponsiveContainer>
      
    
  );

};




CustomLineChartNPKSmall.propTypes = {
  start: PropTypes.string.isRequired,
  measure: PropTypes.string.isRequired,
  x : PropTypes.any,
  y : PropTypes.any,
  stroke : PropTypes.any,
  payload : PropTypes.any,
  active : PropTypes.any,
  label : PropTypes.any,
}

CustomLineChartNPKSmall.defaultProps = {
  start: "-1h",
  measure: "device_frmpayload_data_voltage",
}